
import {modalController} from '@ionic/vue'
import {defineComponent, reactive, ref, computed, onBeforeMount} from 'vue'
import {useStore} from 'vuex'
import SimpleLoginModal from '@/components/Modal/SimpleLoginModal.vue'

export default defineComponent({
  name: 'LoginModal',
  props: {
    cb: null,
  },
  setup(props) {
    const {dispatch} = useStore()

    const validBrowser = ref<boolean>(true)
    const form = reactive({
      birthDate: '',
      name: '',
      phone: '',
    })
    const errorMessage = ref<string>('')

    const isFormValid = computed(() => {
      return form.name && form.phone && form.birthDate
    })

    const lookupUuid = async () => {
      if (!isFormValid.value) {
        errorMessage.value = '모든 정보를 입력해주세요'
        return
      }

      errorMessage.value = ''

      try {
        const result = await dispatch('user/ACT_LOOKUP_UUID', {
          birthDate: form.birthDate,
          name: form.name,
          phone: form.phone,
        })

        if (result && result.uuid) {
          // UUID 저장 완료 → LoginModal 닫고 SimpleLoginModal 열기
          await modalController.dismiss()
          const modal = await modalController.create({
            backdropDismiss: true,
            component: SimpleLoginModal,
            componentProps: {
              cb: props.cb,
            },
            cssClass: 'simple-login-modal',
            id: 'SimpleLoginModal',
            keyboardClose: true,
            mode: 'ios',
            swipeToClose: true,
          })
          return modal.present()
        } else {
          errorMessage.value = '등록되지 않은 사용자입니다'
        }
      } catch (error: any) {
        errorMessage.value = error?.response?.data?.message || '로그인 실패. 다시 시도해주세요'
      }
    }

    onBeforeMount(() => {
      // initialize if needed
    })

    return {
      errorMessage,
      form,
      isFormValid,
      lookupUuid,
      validBrowser,
    }
  },
})
